import React, { FC } from "react";

import Footer from "components/common/Footer/Footer";
import TestHeader from "components/common/TestHeader/TestHeader";
import Announcement from "./Announcement/Announcement";
import SlideShow from "./LandingSlideshow/slideShow";
import Library from "./Library/Library";
import PhotoNews from "./PhotoNews/PhotoNews";
import Services from "./services/Services";
import TextNews from "./TextNews/TextNews";
import VideoNews from "./VideoNews/VideoNews";

import "./Landing.scss";

const Landing: FC = () => {
  return (
    <>
      {/* <TestHeader /> */}
      <SlideShow />
      <Services />
      <Library />
      <TextNews />
      <PhotoNews />
      <VideoNews />
      <Announcement />
      {/* <Footer /> */}
    </>
  );
};

export { Landing };
